export class CatCategoryPromoterModel {
    public promoterCategoryId?:number;
    public description?:string;

    public activeId?:number;
    public createUserId?:number;
    public createDate?:string;
    public modifUserId?:number;
    public modifDate?:string;
}